import { useMemo } from "react";
import { useFormContext } from "react-hook-form";
import { filterTaxIdTypeOptionBySearchValue } from "@/react/utils/paywalls/taxId/helpers";
import type { UseTaxIdFormConfig } from "@/react/utils/paywalls/taxId/useTaxIdForm";
import { useTaxIdForm } from "@/react/utils/paywalls/taxId/useTaxIdForm";
import { usePaywallCheckoutContext } from "@circle-react/contexts/Paywalls/paywallCheckoutContext";
import { Select } from "@circle-react-uikit/Select";
import { CheckoutForm } from "../";
import type { CheckoutFormValuesProps } from "../../../types/CheckoutFormValuesProps";
import { CheckoutFormField } from "../CheckoutFormField";

const addressCountryFieldName =
  "community_member_billing_info_attributes.address_country";
const taxIdTypeFieldName =
  "community_member_billing_info_attributes.tax_id_type";
const taxIdTypeLabelFieldName =
  "community_member_billing_info_attributes.tax_id_type_label";
const taxIdValueFieldName =
  "community_member_billing_info_attributes.tax_id_value";
const fieldNames = {
  addressCountry: addressCountryFieldName,
  taxIdType: taxIdTypeFieldName,
  taxIdTypeLabel: taxIdTypeLabelFieldName,
  taxIdValue: taxIdValueFieldName,
};

export const CheckoutFormTaxIdForm = () => {
  const { watch } = useFormContext<CheckoutFormValuesProps>();
  const {
    community_member_billing_info_attributes: {
      address_country: selectedCountry,
    } = {},
  } = watch();

  const {
    isTaxCollectionEnabled,
    isBrazilianAccountAndProcessorStripeBr: isBrazilianCommunity,
  } = usePaywallCheckoutContext();

  const config = useMemo<UseTaxIdFormConfig>(
    () => ({
      fieldNames,
      selectedCountry,
      isBrazilianCommunity,
      isTaxCollectionEnabled,
    }),
    [selectedCountry, isBrazilianCommunity, isTaxCollectionEnabled],
  );

  const {
    handleTaxIdTypeChange,
    isRequired,
    isTaxIdValueRequired,
    isVisible,
    selectedTaxIdType,
    selectOptions,
    taxIdTypeLabel,
  } = useTaxIdForm(config);

  if (!isVisible) {
    return null;
  }

  return (
    <CheckoutForm.Item name="tax_id" optional={!isRequired}>
      <Select
        variant="single"
        name="taxIdTypeLabel"
        data={selectOptions}
        value={taxIdTypeLabel}
        onChange={handleTaxIdTypeChange}
        filterBy={filterTaxIdTypeOptionBySearchValue}
        hideSelectedItems
      />
      {taxIdTypeLabel && (
        <CheckoutFormField
          className="mt-2 grow"
          type="text"
          name="community_member_billing_info_attributes.tax_id_value"
          placeholder={selectedTaxIdType?.example}
          options={{ required: isTaxIdValueRequired }}
        />
      )}
    </CheckoutForm.Item>
  );
};
